/* eslint-disable no-multi-spaces */
/* eslint-disable key-spacing */
import {
  UPDATE_PROPS,
  GO_TO_ADD_LIABILITY,
  SET_LIABILITY_TYPE_TO_CREATE,
  GO_TO_INDEX,
  BACK,
  DELETE_LIABILITY,
  UPDATE_LIABILITY,
  CONFIRM_DELETE,
  SUBMIT_FORM,
  LOADING
} from './actions'

import { formFieldsForLiabilityType } from './utils/formFieldsForLiabilityType'
import { R } from '@utils/currency'
import { humanizeString } from '@utils/stringMinipulation'
import { 
  totalLiability,
  totalRepayments
} from '@utils/liabilities'

export const SCREEN_STATES = {
  INDEX: 'index',
  CREATE: 'create',
  FORM: 'form',
  DESTROY: 'destroy'
}

export default function reducer (state, { type, payload }) {
  switch (type) {
    case UPDATE_PROPS:
      return {
        ...state,
        liabilities: payload.props.liabilities,
        totalRepayments: R(totalRepayments(payload.props.liabilities)).format(),
        totalLiability: R(totalLiability(payload.props.liabilities)).format(),
      }
    case GO_TO_ADD_LIABILITY:
      return {
        ...state,
        cameFrom: state.screen,
        screen: SCREEN_STATES.CREATE,
        title: 'Choose the type of liability you want to add'
      }
    case GO_TO_INDEX:
      return {
        ...state,
        screen: SCREEN_STATES.INDEX,
        cameFrom: state.screen,
        title: 'Liabilities you currently have'
      }
    case BACK:
      return {
        ...state,
        screen: state.cameFrom,
        cameFrom: state.cameFrom === SCREEN_STATES.FORM ? SCREEN_STATES.INDEX : state.screen
      }
    case SET_LIABILITY_TYPE_TO_CREATE:
      return {
        ...state,
        screen: SCREEN_STATES.FORM,
        cameFrom: state.screen,
        title: humanizeString(payload.liabilityType),
        liabilityIndex: null,
        liability: {},
        formLiabilityType: payload.liabilityType,
        formFields: formFieldsForLiabilityType(),
        submitLabel: 'add liability',
        deleteLabel: 'back to liabilties',
        backLabel: 'back'
      }
    case UPDATE_LIABILITY:
      return {
        ...state,
        screen: SCREEN_STATES.FORM,
        cameFrom: state.screen,
        liabilityIndex: payload.liabilityIndex,
        liabilityId: state.liabilities[payload.liabilityIndex].id,
        liability: { ...state.liabilities[payload.liabilityIndex] },
        formLiabilityType: state.liabilities[payload.liabilityIndex].liability_type,
        title: humanizeString(state.liabilities[payload.liabilityIndex].liability_type),
        formFields: formFieldsForLiabilityType(),
        submitLabel: 'update liability',
        deleteLabel: 'delete liability',
        backLabel: 'back'
      }
    case DELETE_LIABILITY:
      return {
        ...state,
        screen: SCREEN_STATES.DESTROY,
        cameFrom: state.screen,
        liabilityIndex: payload.liabilityIndex,
        liability: state.liabilities[payload.liabilityIndex]
      }
    case SUBMIT_FORM:
      return {
        ...state,
        screen: SCREEN_STATES.INDEX,
        cameFrom: state.screen,
        loading: false
      }
    case CONFIRM_DELETE:
      return {
        ...state,
        screen: SCREEN_STATES.INDEX,
        cameFrom: state.screen,
        loading: false
      }
    case LOADING:
      return {
        ...state,
        loading: true
      }
  }
}

export const propsToState = (props) => ({
  screen:                   SCREEN_STATES.INDEX,
  cameFrom:                 SCREEN_STATES.INDEX,
  title:                    'Liabilities you currently have',
  liabilities:              props.liabilities,
  liability:                {},
  liabilityIndex:           null,
  submitLabel:              null,
  deletelLabel:             null,
  backLabel:                null,
  formFields:               null,
  totalRepayments:     R(totalRepayments(props.liabilities)).format(),
  totalLiability:      R(totalLiability(props.liabilities)).format(),
})
